module.exports = __webpack_public_path__ + "static/media/20220325-1.72a9a4fb.png";